import { render, staticRenderFns } from "./space-grading.vue?vue&type=template&id=d32c5a2c&scoped=true"
import script from "./space-grading.vue?vue&type=script&lang=js"
export * from "./space-grading.vue?vue&type=script&lang=js"
import style0 from "./space-grading.vue?vue&type=style&index=0&id=d32c5a2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32c5a2c",
  null
  
)

export default component.exports